module.exports = __webpack_public_path__ + "ffe68b5e261a6b4b8f08d8921a95e1a3.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./components/Modal/images/small/certificate-of-authenticity.jpg
 ** module id = 409
 ** module chunks = 0
 **/